// extracted by css-extract-rspack-plugin
export default {"Box":"x-axis-selector-module__Box__eMI30T_"};